'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import clsx from 'clsx';
import { AboutSpreadGroupModule } from '@/types/amplience';
import ModuleItem from '@/components/AboutSpreadGroupModule/ModuleItem';
import SliderVariant from '@/components/AboutSpreadGroupModule/SliderVariant';
import ProgressBar from '@/components/ProgressBar/ProgressBar';
export interface AboutSpreadGroupModuleProps {
  content: AboutSpreadGroupModule;
  className?: string;
}
const AboutSpreadGroupTeaserModule: React.FC<AboutSpreadGroupModuleProps> = t0 => {
  const $ = _c(17);
  const {
    content,
    className
  } = t0;
  const {
    headline,
    backgroundColor,
    items
  } = content;
  const isBackgroundBlack = backgroundColor === "black";
  const textColorClass = isBackgroundBlack ? "text-white" : "text-black";
  const bgColorClass = isBackgroundBlack ? "bg-black" : "bg-neutral-100";
  const [progress, setProgress] = useState(0);
  let t1;
  if ($[0] !== bgColorClass || $[1] !== className) {
    t1 = clsx(bgColorClass, className);
    $[0] = bgColorClass;
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== textColorClass) {
    t2 = clsx("text-xl font-bold uppercase sm:text-2xl md:text-[1.75rem] lg:text-[2rem] xl:mb-12", "mb-4 sm:mb-6 lg:mb-8", "xs:w-3/4 sm:w-1/2 md:max-w-1/2 lg:w-2/5", "px-6 md:px-8 lg:px-16 xl:px-22.5", textColorClass);
    $[3] = textColorClass;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== headline || $[6] !== t2) {
    t3 = <h2 className={t2}>{headline}</h2>;
    $[5] = headline;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isBackgroundBlack || $[9] !== items || $[10] !== progress || $[11] !== textColorClass) {
    t4 = items.length < 4 ? <><div className="block sm:hidden"><SliderVariant items={items} textColorClass={textColorClass} isBackgroundBlack={isBackgroundBlack} setProgress={setProgress} /></div><div className={clsx("hidden", "sm:grid sm:grid-cols-3", "gap-8 md:gap-12 lg:gap-16 xl:gap-20", "px-6 md:px-8 lg:px-16 xl:px-22.5")}>{items.map((item, idx) => <ModuleItem imageSizes="30vw" key={idx} item={item} textColorClass={textColorClass} />)}</div></> : <div className="relative"><SliderVariant items={items} textColorClass={textColorClass} isBackgroundBlack={isBackgroundBlack} setProgress={setProgress} isLargeScreen={true} /><div className="px-6 md:px-8 lg:px-16 xl:px-22.5"><ProgressBar progress={progress} isVisible={true} background={isBackgroundBlack ? "black" : "white"} /></div></div>;
    $[8] = isBackgroundBlack;
    $[9] = items;
    $[10] = progress;
    $[11] = textColorClass;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t3 || $[15] !== t4) {
    t5 = <section className={t1}>{t3}{t4}</section>;
    $[13] = t1;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default AboutSpreadGroupTeaserModule;